import { useMutation } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { cancelPayoutRequest } from "./";

export default function useCancelPayoutRequest() {
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ payoutId }) =>
      cancelPayoutRequest(ctx, {
        payoutId,
      })
  });
}
